
import { Component, Vue } from 'vue-property-decorator';
// root mixins
import { RootVariables } from '@mixins/root/root-variables';
import { AnchorEvents } from '@mixins/root/anchor-events';

@Component({
  mixins: [RootVariables, AnchorEvents]
})
export default class App extends Vue {
    mounted () {

    }
}
